<template>
    <div class="channel-subs">
        <div class="row">
            <span class="label">whiteOnly</span>
            <el-switch v-model="result.whiteOnly" />
        </div>
        <div v-if="result.whiteOnly" class="row">
            <span class="label">White Subs</span>
            <div class="sub-items">
                <el-input v-model="result.white_subs" type="textarea" :rows="5"/>
            </div>
        </div>
        <div v-else class="row">
            <span class="label">Block Subs</span>
            <div class="sub-items">
                <el-input v-model="result.block_subs" type="textarea" :rows="5"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
	data() {
		return {
			result:this.value||{},
		};
	},
	props:{
		value:{
			type:Object,
			default(){
				return {};
			}
		},
	},
	watch:{
		result(v){
			this.$emit('input',v);
		},
		value(v){
			if(v && typeof v==='object'){
				this.result = v;
			}else{
				this.result = {};
			}
		}
	},
};
</script>

<style scoped>
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 30px;
}
.sub-items {
	width:300px;
}
.label {
	width: 200px;
	text-align: right;
	padding-right: 20px;
}
.channel-subs {
	display: flex;
	flex-direction: column;
}
</style>
